const selectors = {
  currentImage: '.product-single__photo',
  dataImageId: 'data-image-id',
  thumbnailImage: '.product-single__thumbnail',
  arrowLeft: '.product-image__arrow--left',
  arrowRight: '.product-image__arrow--right',
};

const direction = {
  left: 'left',
  right: 'right',
};

const thumbnailsImages = document.querySelectorAll(selectors.thumbnailImage);

/**
 * Changes image
 *
 * @param {number} index which number of thumbnail should be shown
 */
function changeImage(index) {
  let thumnailIndex = index;
  if (index < 0) thumnailIndex = thumbnailsImages.length - 1;
  else if (index > thumbnailsImages.length - 1) thumnailIndex = 0;
  thumbnailsImages[thumnailIndex].closest('a').click();
}

/**
 * Called on arrow click
 *
 * @param {string} arrowDirection arrow direction
 */
function arrowClick(arrowDirection) {
  const currentImage = document.querySelector(selectors.currentImage);
  const imageIndex = [...thumbnailsImages].findIndex(
    (thumbnail) => thumbnail.dataset.imageId === currentImage.dataset.imageId,
  );

  if (direction.left === arrowDirection) {
    if (imageIndex === -1) changeImage(-1);
    else changeImage(imageIndex - 1);
  } else if (direction.right === arrowDirection) {
    if (imageIndex === -1) changeImage(0);
    else changeImage(imageIndex + 1);
  }
}

document.querySelector(selectors.arrowLeft).addEventListener('click', () => arrowClick(direction.left));
document.querySelector(selectors.arrowRight).addEventListener('click', () => arrowClick(direction.right));
